import {AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild} from "@angular/core";
import {MapsLocationPageComponent} from "../../pages/location/map.location-page.component";


declare const CmSectorEditor: any;
declare const $: any;


@Component({
    selector: "nv-sector-editor",
    templateUrl: "./nv-sector-editor.component.html"
})
export class NvSectorEditorComponent /*implements AfterViewInit, OnDestroy */{
    @Input() parnt:MapsLocationPageComponent;


    @ViewChild("sectorEditorNode") htmlNode: ElementRef;
    editor: any;


    constructor() {
    }


    /*ngAfterViewInit(): void {
        this.editor = new CmSectorEditor(this.htmlNode.nativeElement);
        this.htmlNode.nativeElement.addEventListener("mousewheel", e => {
            e.preventDefault();
        });

        this.parnt.helloFromEditor(this);
    }


    ngOnDestroy(): void {
        this.parnt.byeFromEditor();

    }

    setMap(document: any) {
        const config = {
            mapWidth: document["locationConfig"].tileWidth,
            mapHeight: document["locationConfig"].tileHeight,
            sectors: []
        };

        config.sectors = (document.sectorsConfig.sectors || []).map((item:any):any => {
            return {
                id: item.id,
                x: item.x,
                y: item.y,
                width: item.w,
                height: item.h
            };
        });

        console.log(JSON.stringify(config));

        this.editor.applyEditorState(config);

        // set remove callback
        // set remove callback
    }


    removeById(id: number):void {
        this.editor.removeSectorById(id);
    }


    onAddCallback(callback: (sectorConfig?: any) => void) {
        this.editor.onSectorAdd(callback);
    }


    onRemove(callback: (id?: number) => void) {
        this.editor.onSectorRemove(callback);
    }

    setNextSectorIdGetter(callback: () => number) {
        this.editor.setNextSectorIdGetter(callback);
    }


    onUpdateSector(callback: (sectorConfig?: any) => any) {
        this.editor.onSectorUpdate(callback);
    }

    onMapUpdate(callback: (succeeded: boolean) => void) {
        this.editor.onMapUpdate(callback);
    }

    trySetMapDimensions(ww: number, hh: number) {
        this.editor.setMapDimensions(ww, hh);
    }*/
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-sector-editor/nv-sector-editor.component.ts